import { isTopLevelToolName } from "./surfaces-B1_F0pzt.js";
import { formatToolCall, isToolAvailableInSession } from "./tool-call-formatting-ALc98KqF.js";

//#region src/internal/tool-helpers/ai-conversation-actions.ts
const MAX_SUGGESTED_ACTIONS = 3;
function formatInlineCode(value) {
	const backtickRuns = value.match(/`+/g) ?? [];
	const fenceLength = backtickRuns.reduce((max, run) => Math.max(max, run.length), 0) + 1;
	const fence = "`".repeat(fenceLength);
	const needsPadding = value.startsWith("`") || value.endsWith("`");
	return needsPadding ? `${fence} ${value} ${fence}` : `${fence}${value}${fence}`;
}
/** Builds transcript actions that match the session's direct or catalog surface. */
function getAIConversationSuggestedActions({ organizationSlug, aiConversations, experimentalMode, availableToolNames, directToolNames }) {
	if (aiConversations.length === 0 || !isToolAvailableInSession("get_agent_conversation_details", availableToolNames)) return [];
	const targetIsDirect = directToolNames ? directToolNames.has("get_agent_conversation_details") : isTopLevelToolName("get_agent_conversation_details", experimentalMode);
	const executeToolIsDirect = directToolNames ? directToolNames.has("execute_sentry_tool") : isTopLevelToolName("execute_sentry_tool", experimentalMode);
	const useCatalogGateway = !targetIsDirect && executeToolIsDirect && isToolAvailableInSession("execute_sentry_tool", availableToolNames);
	if (!targetIsDirect && !useCatalogGateway) return [];
	return aiConversations.slice(0, MAX_SUGGESTED_ACTIONS).map((conversation) => {
		const targetArguments = {
			organizationSlug,
			conversationId: conversation.conversationId
		};
		return targetIsDirect ? {
			type: "tool_call",
			toolName: "get_agent_conversation_details",
			arguments: targetArguments,
			reason: "Fetch the full transcript for this agent conversation."
		} : {
			type: "tool_call",
			toolName: "execute_sentry_tool",
			arguments: {
				name: "get_agent_conversation_details",
				arguments: targetArguments
			},
			reason: "Fetch the full transcript for this agent conversation."
		};
	});
}
/** Returns markdown instructions that mirror the callable structured actions. */
function formatAIConversationActionInstructions({ organizationSlug, aiConversations, experimentalMode, availableToolNames, directToolNames }) {
	const actions = getAIConversationSuggestedActions({
		organizationSlug,
		aiConversations,
		experimentalMode,
		availableToolNames,
		directToolNames
	});
	if (actions.length === 0) return ["Agent conversation detail lookup is not available in this session."];
	return actions.map((action) => `Use the Sentry tool ${formatInlineCode(formatToolCall({
		toolName: action.toolName,
		arguments: action.arguments
	}))} to fetch the full transcript.`);
}
/**
* Adds concrete transcript follow-ups to otherwise markdown-first results.
* The markdown remains the compatibility path for clients that do not read
* structured content.
*/
function addAIConversationSuggestedActions({ markdown, organizationSlug, aiConversations, experimentalMode, availableToolNames, directToolNames }) {
	const suggestedActions = getAIConversationSuggestedActions({
		organizationSlug,
		aiConversations,
		experimentalMode,
		availableToolNames,
		directToolNames
	});
	if (suggestedActions.length === 0) return markdown;
	return {
		content: [{
			type: "text",
			text: markdown
		}],
		structuredContent: { suggestedActions }
	};
}

//#endregion
export { addAIConversationSuggestedActions, formatAIConversationActionInstructions, getAIConversationSuggestedActions };
//# sourceMappingURL=ai-conversation-actions-rbKawWyG.js.map